import * as React from "react";
import { AcquisAdmissionApi, BilanCompetenceFichierDto } from "../../../../../../api";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import * as Yup from "yup";
import { useReferential } from "../../../../../../hooks/useReferential";
import { Classes, Dialog } from "@blueprintjs/core";
import styled from "styled-components";
import { FGWalterSelectInput, SmallFormGenerator } from "../../../../../../components";
import { FGTextInput, FieldGroup } from "nsitools-react";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface IBilanCompetenceDocumentEditDialogProps {
  idbilanCompetenceFichier: number;
  onClose: (refresh?: boolean) => void;
}

export const BilanCompetenceDocumentEditDialog: React.FunctionComponent<IBilanCompetenceDocumentEditDialogProps> = ({
  idbilanCompetenceFichier,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(AcquisAdmissionApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return api.acquisAdmissionGetBilanCompetenceFichier({ id: idbilanCompetenceFichier });
        },
        saveApiFn: async (d: BilanCompetenceFichierDto) => {
          return api.acquisAdmissionSaveBilanCompetenceFichier({ BilanCompetenceFichierDto: d });
        },
        onSaved: () => onClose(true)
      }),
      [api, idbilanCompetenceFichier, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idtypeAcquisFichier: Yup.number()
          .nullable()
          .required(t(ETLCodes.Required))
      }),
    [t]
  );

  const [typesAcquisFichier, tLoading] = useReferential(a => a.referentialGetTypesAcquisFichier());

  return (
    <StyledDialog title={t(ETLCodes.UploadFichier)} isOpen={!!idbilanCompetenceFichier} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGTextInput name="fileName" label={t(ETLCodes.Fichier)} readonly />
            <FGWalterSelectInput
              name="idtypeAcquisFichier"
              label={t(ETLCodes.Type)}
              items={typesAcquisFichier}
              loading={tLoading}
            />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
